export const codeMirrorConfig: Readonly<any> = {
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/constants/uiCodemirrorConfig.ts